<template>
    <!--    阀门弹窗-->
    <div class="fm" v-show="valueShow">
    </div>
</template>

<script>
    

    export default {
        name: "valve",
        data() {
            return {

                activeObj: {},
                path: '',
                valueShow: false,
               listData:[
                    {
                        "ZO":"1",
                        "ZC":" ",
                        "name":"smgd0207",
                    },
                    
                    {
                        "ZO":" ",
                        "ZC":"1",
                        "name":"smgd0205",
                    },
                    {
                        "ZO":" ",
                        "ZC":"1",
                        "name":"smgd1102",
                    },
                    {
                        "ZO":" ",
                        "ZC":"1",
                        "name":"smgd2102",
                    },
                    {
                        "ZO":"1",
                        "ZC":" ",
                        "name":"smgd0204",
                    },
                    {
                        "ZO":"1",
                        "ZC":" ",
                        "name":"smgdxf15",
                    },
                    {
                        "ZO":" ",
                        "ZC":"1",
                        "name":"smgd0106",
                    },
                    {
                        "ZO":"1",
                        "ZC":" ",
                        "name":"smgd0501",
                    },
                    {
                        "ZO":" ",
                        "ZC":"1",
                        "name":"smgd3506",
                    },
                    {
                        "ZO":"1",
                        "ZC":" ",
                        "name":"smgd3303",
                    },
                    {
                        "ZO":" ",
                        "ZC":"1",
                        "name":"smgd0201",
                    },
                    
                
                ]
            }
        },
        mounted() {

            window.getValue = this.getValue;
            window.valuechangeShow = this.changeShow;
            window.delivery = this.delivery
            this.getAllData();
        },
        methods: {
            //关闭弹窗
            changeShow() {

                this.valueShow = false

            },
            //获取所有阀门的状态
            getAllData() {
                let listData = [];
                let name = [
                    'smgd0207', 'smgd0205', 'smgd0203', 'smgd0201', 'smgd0208', 'smgd0206', 'smgd0204', 'smgd0202', 'smgd0402', 'smgd0404', 'smgd0406', 'smgd0410', 'smgd0412', 'smgd0105', 'smgd0104', 'smgd0103', 'smgd0102',
                    'smgd0415', 'smgd0414', 'smgd0417', 'smgd0413', 'smgd0416', 'smgd0501', 'smgd0502', 'smgd0108', 'smgd0107', 'smgd0106', 'smgd3602', 'smgd0604', 'smgd0606', 'smgd1401', 'smgd1201', 'smgd1202', 'smgd1203',
                    'smgd3303', 'smgd3506', 'smgd1103', 'smgd1102', 'smgd1303', 'smgd1302', 'smgd1105', 'smgd1104', 'smgd1305', 'smgd1304', 'smgd2101', 'smgd2201', 'smgd2301', 'smgd2102', 'smgd2202', 'smgd2302', 'smgd3101',
                    'smgd3501', 'smgd3102', 'smgd3302', 'smgd3202', 'smgd3402', 'smgd3405', 'smgd3310', 'smgd3201','smgd3301','smgd3401'
                ]
                for (let i = 0; i < name.length; i++) {
                    let obj = {
                        name: '',
                        list: ''
                    }
                        let path = 'zo' + name[i].substring(4);
                    obj.name = name[i]
                   

                    this.listData.push(obj)
                }
            },
            //将获取的值传给三维
            delivery(){
                return this.listData;
            }
        }
    }
</script>

<style scoped>
    .close {
        position: absolute;
        width: 9px;
        height: 9px;
        background: url("./asses/close.png") no-repeat;
        background-size: 100% 100%;
        right: 19px;
        top: 4px;
        cursor: pointer;
    }

    .fm {
        z-index: 999;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 398px;
        height: 232px;
        background: url("./asses/tc4.png") no-repeat;
        background-size: 100% 100%;

    }

    .fm-box {
        position: absolute;
        width: 300px;
        height: 115px;
        top: 50%;
        left: 10%;
        transform: translateY(-50%);
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .fm-box .box-left {
        width: 85px;
        height: 112px;
        background: url("./asses/tc4-f.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        justify-content: center;
        align-items: flex-end;
    }

    .fm-box .box-left p {
        margin-bottom: 10px;
    }

    .fm-box .box-right {
        width: 186px;
        height: 100%;
        display: flex;
        justify-content: space-between;
        flex-flow: wrap;
        align-items: flex-end;
    }

    .fm-box .box-right .switch {
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: 80px;
        height: 15px;
        font-size: 14px;
    }

    .fm-box .box-right .switch .switch-bg {
        width: 27px;
        height: 13px;

        background-size: 100% 100% !important;
        cursor: pointer;
    }

    .box-right-open {
        width: 71px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #22c8bf;
        cursor: pointer;
    }

    .box-right-close {
        width: 71px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #a9b9c1;
        cursor: pointer;
    }

    .fm .close {
        position: absolute;
        width: 9px;
        height: 9px;
        background: url("./asses/close.png") no-repeat;
        background-size: 100% 100%;
        right: 14px;
        top: 18px;
        cursor: pointer;
    }

    .valueopen {
        background: url("./asses/tc4-open.png") no-repeat;
        background-size: 100% 100%;
    }

    .valueclose {
        background: url("./asses/tc4-close.png") no-repeat;
        background-size: 100% 100%;
    }
</style>